@if (events$ | async; as events) {
  <div
    class="h-100"
    [style.max-width.%]="
      !showdetailview || hidedetailview ? '100'
      : split50 ? '50'
      : '66.66'
    ">
    <div class="clr-row nm padding-10 clr-justify-content-between">
      @if (!isListeMode()) {
        <strong style="font-size: x-large; font-weight: lighter">
          {{ currentDate | date: 'LLLL yyyy' : undefined : lang | titlecase }}
        </strong>
      } @else {
        <div></div>
      }

      <clr-button-group class="btn-sm btn-outline">
        @if (!isListeMode()) {
          <clr-button (click)="switchNextPrev(-1)">
            <cds-icon shape="angle" direction="left" [title]="'zurück' | mrTranslate" />
          </clr-button>
          <clr-button (click)="today()">{{ 'Heute' | mrTranslate }}</clr-button>
          <clr-button (click)="switchNextPrev(+1)">
            <cds-icon shape="angle" direction="right" [title]="'weiter' | mrTranslate" />
          </clr-button>
          <clr-button (click)="capture()">
            <cds-icon shape="camera" [title]="'Kalender als Bild speichern' | mrTranslate" />
          </clr-button>
        }
        <clr-button (click)="isListeMode.set(!isListeMode())">
          <cds-icon
            [shape]="isListeMode() ? 'calendar' : 'view-list'"
            [attr.title]="(isListeMode() ? 'zeige Kalender' : 'zeige Prüfungsliste') | mrTranslate" />
        </clr-button>

        @if (isListeMode()) {
          <clr-button (click)="excel()">
            <cds-icon shape="excel" [title]="'Liste nach Excel exportieren' | mrTranslate" />
          </clr-button>
          <clr-button
            (click)="filterStore.deleteAllFilters()"
            [disabled]="pruefungsListe().rows.length == filterStore.filteredRows().length">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="filter-off" />
              <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                {{ 'Alle Filter zurücksetzen' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </clr-button>
        }
      </clr-button-group>
      @if (!isListeMode()) {
        <span>{{ s_view | dayjs_to_date | date: 'MM.yy' }} - {{ e_view | dayjs_to_date | date: 'MM.yy' }}</span>
      } @else {
        <div></div>
      }
    </div>

    <ng-template
      #customCellTemplate
      let-day="day"
      let-openDay="openDay"
      let-locale="locale"
      let-tooltipPlacement="tooltipPlacement"
      let-highlightDay="highlightDay"
      let-unhighlightDay="unhighlightDay"
      let-eventClicked="eventClicked"
      let-tooltipAppendToBody="tooltipAppendToBody"
      let-tooltipDelay="tooltipDelay"
      let-trackByEventId="trackByEventId">
      <div
        class="cal-cell-top"
        style="min-height: 0"
        [attr.aria-label]="{ day: day, locale: locale } | calendarA11y: 'monthCell'">
        <span aria-hidden="true">
          <span class="cal-day-number">{{ day.date | calendarDate: 'monthViewDayNumber' : locale }}</span>
        </span>
      </div>
      @if (day.events.length) {
        <div class="cal-events">
          @for (event of day.events; track event.title) {
            <div
              (mouseenter)="highlightDay.emit({ event: event })"
              (mouseleave)="unhighlightDay.emit({ event: event })"
              [mwlCalendarTooltip]="event.title | calendarEventTitle: 'monthTooltip' : event"
              [tooltipPlacement]="tooltipPlacement"
              [tooltipEvent]="event"
              [tooltipAppendToBody]="tooltipAppendToBody"
              [tooltipDelay]="tooltipDelay"
              (mwlClick)="eventClicked.emit({ event: { event, all: day.events }, sourceEvent: $event })"
              [attr.aria-hidden]="{} | calendarA11y: 'hideMonthCellEvents'">
              @switch (event.title) {
                @case ('Wartungen') {
                  <span href="javascipt:void(0)" class="label label-purple clickable">
                    <span class="text"><cds-icon shape="wartung" size="15" /></span>
                    <span class="badge">{{ event.meta.events.length }}</span>
                  </span>
                }
                @case ('Begehungen') {
                  <span href="javascipt:void(0)" class="label label-orange clickable">
                    <span class="text"><cds-icon shape="clock" size="15" /></span>
                    <span class="badge">{{ event.meta.events.length }}</span>
                  </span>
                }
                @default {
                  <span href="javascipt:void(0)" class="label label-blue clickable">
                    <span class="text"><cds-icon shape="check-circle" size="20" /></span>
                    <span class="badge">{{ event.meta.events.length }}</span>
                  </span>
                }
              }
            </div>
          }
        </div>
      }
    </ng-template>

    <ng-template
      #customOpenDayEventsTemplate
      let-locale="locale"
      let-events="events"
      let-eventClicked="eventClicked"
      let-isOpen="isOpen"
      let-trackByEventId="trackByEventId">
      @if (isOpen) {
        <!-- <div class="cal-open-day-events" role="application"> -->
        <div class="card" style="z-index: 99" role="application">
          <div class="card-block">
            <clr-accordion>
              @for (group of events; track group.title) {
                <clr-accordion-panel [(clrAccordionPanelOpen)]="group.meta.isOpened">
                  <clr-accordion-title>
                    @switch (group.title) {
                      @case ('Wartungen') {
                        <cds-icon shape="wartung" size="15" />
                      }
                      @case ('Begehungen') {
                        <cds-icon shape="clock" size="15" />
                      }
                      @default {
                        <cds-icon shape="check-circle" size="20" />
                      }
                    }
                    {{ group.title | mrTranslate }}
                  </clr-accordion-title>
                  <clr-accordion-content *clrIfExpanded>
                    <cdk-virtual-scroll-viewport itemSize="24" class="w-100p" style="height: 25vh">
                      <div *cdkVirtualFor="let event of group.meta.events; trackBy: trackByEventId">
                        <cds-icon
                          [shape]="'objekttyp' + event.meta.icon"
                          size="20"
                          style="color: black"
                          class="margin-3-r" />

                        <mwl-calendar-event-title
                          [event]="event"
                          view="month"
                          (mwlClick)="eventClicked.emit({ event: event, sourceEvent: $event })"
                          (mwlKeydownEnter)="eventClicked.emit({ event: event, sourceEvent: $event })"
                          tabindex="0"
                          [attr.aria-label]="{ event: event, locale: locale } | calendarA11y: 'eventDescription'" />
                      </div>
                    </cdk-virtual-scroll-viewport>
                  </clr-accordion-content>
                </clr-accordion-panel>
              }
            </clr-accordion>
          </div>
        </div>
      }
    </ng-template>

    @if (isListeMode()) {
      <div class="h-60 padding-10">
        @if (listeResource.isLoading()) {
          <clr-spinner class="centred" />
        } @else {
          <clr-datagrid
            class="datagrid-compact h-100"
            [clrDgSelectionType]="'single'"
            [clrDgSelected]="[selectedRow()]"
            (clrDgSelectedChange)="selectedRow.set($event[0])"
            [clrDgItemsIdentityFn]="row => row?.OSTAMMID">
            @for (column of pruefungsListe().columns; track column.id) {
              <clr-dg-column [clrDgField]="column.id">
                <clr-dg-filter [attr.data-test-id]="'datagrid-kalender-col-filter-' + column.id">
                  <app-column-filter
                    [column]="column"
                    [title]="column.id"
                    [objektTypIconValue]="filterStore.iconMap()"
                    [uniqueColumnValues]="filterStore.uniqueValues()[column.id]"
                    (changes)="filterStore.onChange($event)" />
                </clr-dg-filter>
                <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: [] }">
                  {{ column.id | titlecase }}
                </ng-container>
              </clr-dg-column>
            }
            <ng-template
              clrVirtualScroll
              let-row
              [clrVirtualRowsOf]="filterStore.filteredRows()"
              [clrVirtualRowsTrackBy]="(_, row) => row?.OSTAMMID"
              [clrVirtualRowsItemSize]="32">
              <clr-dg-row [clrDgItem]="row">
                @for (cell of pruefungsListe().columns; track cell.id) {
                  @if (cell.id == 'Fälligkeit in Tagen') {
                    <clr-dg-cell class="name-cell" [class.invalid-red]="row['Terminstatus'] == 'überfällig'">
                      @if (row['Terminstatus'] == 'überfällig') {
                        <cds-icon class="grid-icon invalid-red margin-3-r" size="20" shape="exclamation-triangle" />
                      }
                      <span>{{ row['Fälligkeit in Tagen'] }}</span>
                    </clr-dg-cell>
                  } @else {
                    <clr-dg-cell><app-icon-dg-cell [column]="cell" [row]="row" /></clr-dg-cell>
                  }
                }
              </clr-dg-row>
            </ng-template>
            <clr-dg-footer>{{ filterStore.filteredRows().length }}</clr-dg-footer>
          </clr-datagrid>
        }
      </div>
    } @else {
      <div id="capture" class="h-60 padding-10">
        <mwl-calendar-month-view
          [viewDate]="currentDate"
          [events]="events"
          (dayClicked)="dayClicked($event.day)"
          [activeDayIsOpen]="activeDayIsOpen"
          (eventClicked)="handleEvent($event.event)"
          [ngClass]="{ activeDayIsOpen }"
          [cellTemplate]="customCellTemplate"
          [openDayEventsTemplate]="customOpenDayEventsTemplate"
          [locale]="lang"></mwl-calendar-month-view>
      </div>
    }
  </div>
}
@if (showdetailview) {
  <div #dvwrapper id="wrapperdetailview" [ngClass]="{ sidenavenlarged, split50, hidedetailview }">
    <app-detailview
      [ostammid]="_ostammid"
      [rechte]="rechte"
      [kpruvid]="kpruvid()"
      [progressbarenlarged]="progressbarenlarged"
      [expanded]="sidenavenlarged"
      [hidden]="hidedetailview"
      [split50]="split50"
      (enlarge)="enlargeSidenav($event)"
      (enlargePB)="enlargeProgressbar(true)"
      (reload)="reloadDetailview()"
      (progressData)="showProgressData($event)"
      (indexScrub)="handleScrub($event)"
      #detailView></app-detailview>
  </div>
}
@if (showprogressbar) {
  <div id="progresstrigger" [class.bottom]="!progressbarenlarged">
    <div class="wrap" (click)="enlargeProgressbar()">
      <cds-icon
        shape="angle"
        [direction]="progressbarenlarged ? 'down' : 'up'"
        class="expandProgressbarButton cursor-pointer" />
    </div>
  </div>
  @if (progressbarenlarged) {
    <footer id="wrapperprogressbars" class="clr-row nxm clr-align-items-center">
      <app-progressbar
        [dataIn]="progressbars"
        [indexScrub]="indexScrub"
        (enlargeProgressbar)="enlargeProgressbar(true)"
        style="display: inline-block; width: calc(100% - 35px)" />
    </footer>
  }
}
